import { MDFCore } from '@adp-wfn/mdf-core';
const loggingFunctions = ['debug', 'dir', 'error', 'info', 'log', 'trace', 'warn'];

const logger = (...logArgs: any[]) => {
  if (MDFCore?.shouldLog()) {
    let logFunction = 'log';
    let logParams = logArgs;

    if (typeof logArgs[0] === 'string' && loggingFunctions.includes(logArgs[0])) {
      logFunction = logArgs[0];
      logParams = logArgs.slice(1);
    }

    console[logFunction](...logParams);
  }
};

export default logger;
